import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import * as Ci from "react-icons/ci";
import { AppContext } from "../../../context/AppContext";
import Utils from "../../../utils/Utils";
import { useNavigate } from "react-router-dom";
import { getStatusColour } from "../../../constants/ReservationStatus";

function GlobalSearch() {
  const navigate = useNavigate();
  const { enquiriesHistory, upcomingwithTodays, reservationLoading } =
    useContext(AppContext);

  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const mergedEnquiries = useMemo(() => {
    const a = Array.isArray(enquiriesHistory) ? enquiriesHistory : [];
    const b = Array.isArray(upcomingwithTodays) ? upcomingwithTodays : [];
    return [...a, ...b];
  }, [enquiriesHistory, upcomingwithTodays]);

  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    const q = keyword.trim();
    if (!q) {
      setResults([]);
      setSearching(false);
      return;
    }

    setSearching(true);

    timeoutRef.current = setTimeout(() => {
      const query = q.toLowerCase();

      const filtered = mergedEnquiries.filter((enquiry) => {
        const formattedID = (enquiry?.formattedID ?? "")
          .toString()
          .toLowerCase();
        const name = (enquiry?.name ?? "").toString().toLowerCase();
        const email = (enquiry?.email ?? "").toString().toLowerCase();

        return (
          formattedID.includes(query) ||
          name.includes(query) ||
          email.includes(query)
        );
      });

      setResults(filtered);
      setSearching(false);
    }, 300);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [keyword, mergedEnquiries]);

  return (
    <div className="global_search">
      <div className="search_wrapper">
        <input
          type="text"
          name="search"
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
          placeholder="Search reservations."
          disabled={reservationLoading}
          autoComplete="off"
        />
        {searching && <span className="searching_hint">Searching…</span>}
        {!searching && keyword.length != 0 && results.length === 0 && (
          <span className="searching_hint">No matches found!</span>
        )}
        <Ci.CiSearch />
      </div>

      {results.length > 0 && (
        <div className="search_results">
          {results.map((item) => (
            <div
              className="search_result_item"
              key={item.id}
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/view-reservation/${item.id}`)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/view-reservation/${item.id}`);
                }
              }}
            >
              <div className="result_item_header">
                <span className="result_item_id">{item.formattedID}</span>{" "}
                <span
                  className="result_item_status"
                  style={{
                    backgroundColor: getStatusColour(item.status).bg,
                    color: getStatusColour(item.status).text,
                  }}
                >
                  {item.status}
                </span>
                <br />
                <span className="result_item_name text-capitalize">
                  {item.name}
                </span>
                <span className="result_item_date ps-3">
                  {item.bookingTime ? Utils.formatDate(item.bookingTime) : ""}
                </span>
              </div>

              <div className="result_item_contact">
                <span className="sub_items">{item.email}</span>
                <span className="sub_items">{item.phone}</span>
                <span className="sub_items">{item.chairs}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default GlobalSearch;
